import { API_URL } from "../BaseUrl"

export const GET_LOGGED_IN_USER_URL = `${API_URL}/users/getlogged`;
